import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { MedicalVisit } from "../types/FormTypes";
import * as Yup from "yup";
import { medicalVisitAtom } from "./AddCertificate";
import { useRef } from "react";
import { useIsAddMoreTrue } from "./AddMore";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  ErrorList,
  Button,
  handleSubmitClick,
  Progressbar,
  DatePicker,
  MultipleFileUploadField,
  Heading,
} from "@ogt/ui";

export default function ByPublic() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();

  const [formData, setFormData] = useAtom(medicalVisitAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const [isAddMoreTrue] = useIsAddMoreTrue();
  const progress = isAddMoreTrue ? 87 : 62;

  return (
    <div>
      <Formik<MedicalVisit>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });
          navigate("../kostnader-for-overnattning");
        }}
        initialValues={{
          ...formData,
          ...{
            dateTo: "",
            dateFrom: "",
            travelDescription: "",
          },
        }}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
        validationSchema={Yup.object().shape({
          receipts: Yup.array().min(
            1,
            "Vänligen bifoga ett intyg innan du går vidare."
          ),
        })}
      >
        {({ errors, touched, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-40 w-full max-w-xs mb-4">
                {isAddMoreTrue ? (
                  <Progressbar percentage={progress} />
                ) : (
                  <Progressbar percentage={progress} />
                )}
              </div>
            </div>
            <Form ref={formRef}>
              <Box>
                <>
                  <Heading progress={progress} headingRef={h2Ref} focusable>
                    Om resan
                  </Heading>

                  <ErrorList errors={errors} />

                  <Heading as="h3">
                    Resa med kollektivtrafik, taxi eller flyg
                  </Heading>
                  <p>
                    Här bifogar du alla resekvitton till den vårdgivare som står
                    i intyget du bifogade i steg innan.{" "}
                  </p>

                  <p>
                    Det viktigaste är att priset framgår i dokumentet du
                    bifogar. Till exempel accepteras inte enbart en QR-kod.{" "}
                  </p>
                  <p className="mb-8">OBS! Resa med sjuktaxi ersätts ej.</p>

                  <Heading as="h3" className="mb-6">
                    2. Ange datum när du reste med kollektivtrafik
                    (Obligatorisk)
                  </Heading>
                  <div className="md:flex mb-10 md:w-11/12">
                    <div className="mb-6 md:mb-0 md:mr-8 md:w-1/2">
                      <DatePicker
                        name="dateTo"
                        label="Till Vårdenhet (Obligatorisk)"
                        value={formData.dateTo}
                        disableFutureDates
                      />
                    </div>
                    <div className="md:w-1/2">
                      <DatePicker
                        name="dateFrom"
                        label="Från Vårdenhet (Obligatorisk)"
                        value={formData.dateTo}
                        disableFutureDates
                      />
                    </div>
                  </div>

                  <MultipleFileUploadField
                    currentFiles={values.receipts}
                    multiple={true}
                    label="Bifoga kvitton eller biljetter för din resa (Obligatorisk)"
                    inputId="receipts"
                    inputName="receipts"
                  />
                </>
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn secondary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
